import { useEffect, useMemo, useState } from 'react';
import { captureException } from '@sentry/react';
import { getPortalData } from '@bynder/portal-and-user-data';
import { API } from './api';
import { TreatmentKeys } from '../types';

const FALLBACK_SPLIT_TREATMENT = 'off';

export function useSplit(splitName: TreatmentKeys, noCache = false): boolean {
	const [treatment, setTreatment] = useState<string | undefined>();

	useEffect(() => {
		getPortalData()
			.then((portal) => {
				const attributes = portal?.dateCreated
					? { 'portal-created-date': new Date(portal.dateCreated).getTime() }
					: undefined;

				return API.getFeatureTreatment(splitName, noCache, attributes);
			})
			.then((response) => {
				setTreatment(response.treatment);
			})
			.catch((error) => {
				setTreatment(FALLBACK_SPLIT_TREATMENT);
				console.error(
					`Something went wrong while fetching the ${splitName} Split treatment`,
					error,
				);
				captureException(error);
			});
	}, [splitName, noCache]);

	return treatment === 'on';
}

export function useMemoizedSplit(splitKey: TreatmentKeys) {
	const splitValue = useSplit(splitKey);

	return useMemo(() => splitValue, [splitValue]);
}
